import React, {useState } from  'react';

// Modules
import Slider from 'react-slick';

// App
import { assetBase } from '../../../config';
import { alignment, animation, color } from '../../../core/editorOptions';
import { decodeHtmlEntities } from '../../../utils/helpers';

// UI components
import {ChevronLeft, ChevronRight} from 'react-feather';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

function PrevArrow(props) {
  const {className, style, onClick, variant} = props;
  if(variant ==='artotel'){
    return <ChevronLeftIcon onClick={onClick} className={className} style={{style}}  />;
  }
  else{
    return <ChevronLeft onClick={onClick} className={className} style={{style}}  />;
  }
}

function NextArrow({className, style, onClick, variant}) {
  if(variant ==='artotel'){
    return <ChevronRightIcon onClick={onClick} className={className} style={{style}}  />;
  }
  else{
    return <ChevronRight onClick={onClick} className={className} style={{style}} />;
  }
}

function Title({block}) {
  const blockColor = color(block, true);
  let styles = {};

  if (blockColor && blockColor.length > 0) {
    styles = {
      color: blockColor
    };
  }

  const text = decodeHtmlEntities(block?.data?.text);

  return <h1 className={`slide-title ${animation(block)} ${alignment(block)}`} style={styles}>{text}</h1>;
}

export default function ImageGallery(props) {
  const [activeSlide, setActiveSlide] = useState(0);
  const images = props.images;
  const title = props.title;

  const settings = {
    // dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "60px",
    variableWidth: true,
    prevArrow: <PrevArrow variant={props.variant ? props.variant : ''} />,
    nextArrow: <NextArrow variant={props.variant ? props.variant : ''} />,
    afterChange: current => setActiveSlide(current)
  };

  return (
    <>
      {title && (
        <Title block={title} />
      )}
      <div className='gallery-container'>
        <span className='gallery-counter'>{activeSlide+1 + '/' + images.length}</span>
        <Slider {...settings} >
          {images.map((image, index) => {
            let url = image.url;

            if (props.live) {
              if (props.isLibrary && props.initial_presentation) {
                url = `${assetBase}/presentations/${props.initial_presentation}/${props.initial_presentation}/${url}`;
              } else {
                url = `${assetBase}/presentations/${props.presentation_id}/${props.presentation_id}/${url}`;
              }
            }

            return (
              <div key={`item-${index}`} className='gallery_image' style={{width: 768}}>
                <img src={url} data-mid={image.mid} alt={image.caption ? image.caption : ''} />
                {image.caption && (
                  <span className='caption' dangerouslySetInnerHTML={{__html: decodeHtmlEntities(image.caption)}} />
                )}
              </div>
            );
          })}
        </Slider>
      </div>
    </>
  );
};
